module.exports = __webpack_public_path__ + "img/b1.6e1461d5.png";